import keys from "constants/keys";
import {
  DEVICES_LIST_SUCCESS,
  DEVICES_COMMON_LOADER_VISIBILITY,
  UPDATE_STEP_COUNTER_SUCCESS,
  SET_SELECTED_DEVICE_DETAILS,
  DEVICES_SIGNAL_LIST_SUCCESS,
  SET_SELECTED_DEVICE_DETAIL,
  ANELTO_TIME_INTERVAL_SUCCESS,
  FREEUS_TIME_INTERVAL_SUCCESS,
  DEVICES_SIGNAL_LIST_REQUEST,
  RING_DEVICE_SUCCESS,
  CLAIRVOYANT_TIME_INTERVAL_SUCCESS,
  DEVICE_DETAIL_LOADER,
  EVIEW_DEVICE_TIMELINE_SUCESS,
  BREADCRUM_DEVICE_DETAIL_SUCCESS,
  BREADCRUM_DEVICE_DETAIL_REQUEST,
  BREADCRUM_DEVICE_DETAIL_LOADER,
  DEVICE_REFRESH_VISIBILITY,
  DEVICE_DETAIL_MANUAL_REFRESH_LOADER,
  DEVICE_SYNC_HISTORY_SUCESS,
  FETCH_MORE_DEVICE_SYNC_HISTORY_SUCCESS,
  DEVICE_SYNC_SUCESS,
  GET_DEVICE_DETAILS_REQUEST,
  GET_DEVICE_DETAILS,
  DEVICE_SYNC_LOG,
  RESET_DEVICE_SYNC_LOG,
  DEVICE_STATUS_REQUEST,
  DEVICE_STATUS_SUCCESS,
  RESET_DEVICE_STATUS,
  DEVICE_STATUS_FAILURE,
} from "./actionTypes";

const INITIAL_STATE = {
  loading: false,
  deviceList: [],
  deviceSignalHistory: [],
  selectedDeviceData: {},
  aneltoDeviceDetails: localStorage.getItem(keys.aneltoDeviceDetail)
    ? JSON.parse(localStorage.getItem(keys.aneltoDeviceDetail))
    : {},
  freeusDeviceDetails: localStorage.getItem(keys.freeusDeviceDetail)
    ? JSON.parse(localStorage.getItem(keys.freeusDeviceDetail))
    : {},
  clairvoyantDeviceDetails: localStorage.getItem(keys.clairvoyantDeviceDetail)
    ? JSON.parse(localStorage.getItem(keys.clairvoyantDeviceDetail))
    : {},
  selectedDeviceDetails: localStorage.getItem(keys.selectedDeviceDetail)
    ? JSON.parse(localStorage.getItem(keys.selectedDeviceDetail))
    : {},
  aneltoIntervals: [],
  freeusIntervals: [],
  clairvoyantIntervals: [],
  eViewIntervalArray: [],
  ringDeviceSuccess: false,
  lastDate: null,
  deviceDetailLoading: false,
  breadcrumData: [],
  devicePullRefresh: false,
  manualRefreshLoading: false,
  deviceRefreshData: null,
  deviceSyncHistory: [],
  deviceSyncLogs: [],
  deviceStatus: null,
  deviceStatusLoading: false,
};

const deviceReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {

    case DEVICES_COMMON_LOADER_VISIBILITY:
      return {
        ...state,
        loading: action?.payload,
      };
    case DEVICE_REFRESH_VISIBILITY:
      return {
        ...state,
        devicePullRefresh: action?.payload,
      };
    case DEVICE_DETAIL_MANUAL_REFRESH_LOADER:
      return {
        ...state,
        manualRefreshLoading: action?.payload,
      };
    case DEVICE_DETAIL_LOADER:
      return {
        ...state,
        deviceDetailLoading: action?.payload,
      };
    case DEVICES_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        deviceList: action?.payload,
      };
    case UPDATE_STEP_COUNTER_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case SET_SELECTED_DEVICE_DETAILS:
      return {
        ...state,
        loading: false,
        selectedDeviceData: action?.payload,
      };
    case DEVICES_SIGNAL_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        deviceSignalHistory: [],
      };
    case DEVICES_SIGNAL_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        deviceSignalHistory: action?.payload?.data,
        lastDate: action?.payload?.last_signal_date,
      };
    case SET_SELECTED_DEVICE_DETAIL: {
      return {
        ...state,
        loading: false,
        deviceDetailLoading: false,
        selectedDeviceDetails: action?.payload,
        deviceStatus: null,
        deviceStatusLoading: false,
      };
    }

    case ANELTO_TIME_INTERVAL_SUCCESS: {
      return {
        ...state,
        aneltoIntervals: action?.payload,
      };
    }
    case FREEUS_TIME_INTERVAL_SUCCESS: {
      return {
        ...state,
        freeusIntervals: action?.payload,
      };
    }
    case CLAIRVOYANT_TIME_INTERVAL_SUCCESS: {
      return {
        ...state,
        clairvoyantIntervals: action?.payload,
      };
    }
    case EVIEW_DEVICE_TIMELINE_SUCESS: {
      return {
        ...state,
        eViewIntervalArray: action?.payload,
      };
    }

    case RING_DEVICE_SUCCESS: {
      return {
        ...state,
        ringDeviceSuccess: action?.payload,
      };
    }
    case BREADCRUM_DEVICE_DETAIL_REQUEST:
      return {
        ...state,
        breadCrumloading: true,
      };
    case BREADCRUM_DEVICE_DETAIL_SUCCESS:
      return {
        ...state,
        breadcrumData: action?.payload,
        breadCrumloading: false,
      };
    case BREADCRUM_DEVICE_DETAIL_LOADER:
      return {
        ...state,
        breadCrumloading: action?.payload,
      };
    case DEVICE_SYNC_HISTORY_SUCESS:
      return {
        ...state,
        loading: false,
        deviceSyncHistory: action?.payload,
      }
    case FETCH_MORE_DEVICE_SYNC_HISTORY_SUCCESS:
      const existingHistory = state?.deviceSyncHistory?.syncHistory || [];
      const newHistory = action?.payload?.syncHistory || [];
      return {
        ...state,
        loading: false,
        deviceSyncHistory: {
          ...action?.payload,
          syncHistory: [...existingHistory, ...newHistory],
        },
      }
    case GET_DEVICE_DETAILS: {
      return {
        ...state,
        deviceDetails: action?.payload,
                  deviceDetailLoading: false,
        manualRefreshLoading: false,
      }

    }
    case GET_DEVICE_DETAILS_REQUEST: {
      return {
        ...state,
        deviceDetailLoading: true,
        manualRefreshLoading: false,
      }
    }
    case DEVICE_SYNC_SUCESS: {
      return {
        ...state,
        deviceSyncData: action?.payload,
        deviceDetails: {
          ...state?.deviceDetails,
          syncHistory: {
            ...state?.deviceDetails?.syncHistory,
            syncStatus: action?.payload?.syncStatus,
            syncRequestedOn: action?.payload?.syncRequestedOn// Current timestamp
          }
        }
      }
    }
    case DEVICE_SYNC_LOG: {
      return {
        ...state,
        deviceSyncLogs: [...state?.deviceSyncLogs, action?.payload]
      }
    }
    case RESET_DEVICE_SYNC_LOG: {
      return {
        ...state,
        deviceSyncLogs: []
      }
    }
    case DEVICE_STATUS_REQUEST: {
      return {
        ...state,
        deviceStatusLoading: true,
      };
    }
    case DEVICE_STATUS_SUCCESS: {
      return {
        ...state,
        deviceStatus: action?.payload,
        deviceStatusLoading: false,
      };
    }
    case DEVICE_STATUS_FAILURE: {
      return {
        ...state,
        deviceStatusLoading: false,
      };
    }
    case RESET_DEVICE_STATUS: {
      return {
        ...state,
        deviceStatus: null,
        deviceStatusLoading: false,
      }
    }
    default:
      return state;
  }
};

export default deviceReducer;
